import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import {Link} from "react-router-dom";
import {changeContract} from "../Contract/contractSlice";
import {useDispatch} from "react-redux";

export default function ModuleTabs() {

    const [value, setValue] = React.useState(null);

    const dispatchContract = useDispatch();

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 0) {
            dispatchContract(changeContract({
                participationsTabsIndex: 0,
                residualsTabsVisible: false
                ,contractGridVisible: true
                ,contractDrawerMode: null
                ,contractDrilldownVisible: false
                ,contractSearchVisible: false
                ,contractConfigVisible: false
                ,contractView: null
                ,participationsTabsVisible: true
                ,royaltiesTabsVisible: false
                ,cGridRefresh: false
                ,module: 'Participations',
                contractGridAPI: "PartsStandards"
            }))};
            if (newValue === 1) {
                dispatchContract(changeContract({
                    residualsTabsIndex: 0,
                    residualsTabsVisible: true
                    ,contractGridVisible: true
                    ,contractDrawerMode: null
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    ,participationsTabsVisible: false
                    ,royaltiesTabsVisible: false
                    ,cGridRefresh: false
                    ,module: 'Residuals',
                    contractGridAPI: "CBA"
                    }))};
                if (newValue === 2) {
                    dispatchContract(changeContract({
                        royaltiesTabsIndex: 0,
                        residualsTabsVisible: false
                        ,contractGridVisible: true
                        ,contractDrawerMode: null
                        ,contractDrilldownVisible: false
                        ,contractSearchVisible: false
                        ,contractConfigVisible: false
                        ,contractView: null
                        ,participationsTabsVisible: false
                            ,royaltiesTabsVisible: true
                        ,cGridRefresh: false
                        ,module: 'Royalties',
                        contractGridAPI: "RoyalStandards"
                    }))};
    };

    // const residualsBanner = () => {
    //     setAppBarBanner("residuals")
    // };

    return (
        <Box sx={{pt: 2, width: '100%', height: 75, bgcolor: 'background.paper' }}>
            <Tabs value={value} defaultValue={"Collective Bargaining Agreements"}
                // initialState={setValue("Collective Bargaining Agreements")}
                  onChange={handleChange} centered>
                <Tab  label="Participations"
                      component={Link} to={"/Participations"}
                      sx={{
                          mx: 4,
                          fontSize: '1.2rem',
                          fontWeight: 500,
                          // textTransform: 'none'   // optional: prevents ALL CAPS
                      }}/>
                <Tab
                    label="Residuals"
                    component={Link} to={"/ResidualsFrontend"}
                    sx={{
                        mx: 4,
                        fontSize: '1.2rem',
                        fontWeight: 500,
                        // textTransform: 'none'   // optional: prevents ALL CAPS
                    }}
                />
                <Tab label="Royalties"
                component={Link} to={"/Royalties"}
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}/>
                {/*component={Link} to={"/Participations"}/>*/}
            </Tabs>
        </Box>
    );
}
